import { Controller } from "@hotwired/stimulus";

const AUTO_SIGN_IN_FIELD = "easy_setting[selected_identity_provider_name]";

export default class extends Controller {
  static targets = ["loginPageOptions"];

  /** @param {Event} event */
  toggle(event) {
    const field = event.target;

    if (!(field instanceof HTMLInputElement) || field.name !== AUTO_SIGN_IN_FIELD) return;

    this.loginPageOptionsTarget.hidden = field.value !== "";
  }
}
